import { AppService } from './services/app.service';

export function appInitializerFactory(appService: AppService): () => void {
  return () => appService.initStoreData();
}
